import script from "./ThemeLeaderboard.vue?vue&type=script&setup=true&lang=js"
export * from "./ThemeLeaderboard.vue?vue&type=script&setup=true&lang=js"

import "./ThemeLeaderboard.vue?vue&type=style&index=0&id=1165d061&scoped=true&lang=scss"
script.__scopeId = "data-v-1165d061"

export default script